import useAccount from '../useAccount'

/**
 * manages the whole cart. can add, remove and update cart items
 * as long as the cart was not initially fetched the prop "setup" is false
 */
export default function useCart() {
  const account = useAccount()
  return account.cart
}
